import { useTranslation } from 'react-i18next';

export const ns = 'user-list-page';
export const useUserListPageTranslation = () => useTranslation(ns);
export const ruRu = (__LOCALE_RU__ ? ({
  [ns]: {
    title: 'Пользователи',
    users_found: 'Найдено пользователей: {{count}}',
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [ns]: {
    title: 'Users',
    users_found: 'Users found: {{count}}',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [ns]: {
    title: 'Usuarios',
    users_found: 'Los usuarios encontraron: {{count}}',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [ns]: {
    title: 'Usuários',
    users_found: 'Usuários encontraram: {{count}}',
  },
}) : {}) as Record<string, unknown>;
